import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  constructor(private apiService: ApiBaseService) { }

  getCompanies(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/GetCompanies', payLoad, true, false);
  }

  getCompanyDetails(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/GetCompanyDetails', payLoad, true, false);
  }

  addCompany(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/AddCompany', payLoad, true, false);
  }

  writeCompanyPersonShare(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/WriteCompanyPersonShare', payLoad, true, false);
  }

  removePersonFromCompany(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/RemovePersonFromCompany', payLoad, true, false);
  }

  getPersons(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/GetPersons', payLoad, true, false);
  }

  getPersonDetails(payload: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/GetPersonDetails', payload, true, false);
  }

  addPerson(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ContactsService/AddPerson', payLoad, true, false);
  }
}
